/// <amd-module name="Repos/CommitActions/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\commit-actions\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Git from "Repos/Common/Contracts/Git";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve statistics for multiple commits
     * 
     * @param searchCriteria - Base Commit and List of Target Commits to compare.
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     */
    getBranchStatsBatch(searchCriteria: Git.GitQueryBranchStatsCriteria, repositoryId: string, project?: string): Promise<Git.GitBranchStats[]>;
    /**
     * Queries the provided repository for its refs and returns them.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param filter - [optional] A filter to apply to the refs (starts with).
     * @param includeLinks - [optional] Specifies if referenceLinks should be included in the result. default is false.
     * @param includeStatuses - [optional] Includes up to the first 1000 commit statuses for each ref. The default value is false.
     * @param includeMyBranches - [optional] Includes only branches that the user owns, the branches the user favorites, and the default branch. The default value is false. Cannot be combined with the filter parameter.
     * @param latestStatusesOnly - [optional] True to include only the tip commit status for each ref. This option requires \`includeStatuses\` to be true. The default value is false.
     * @param peelTags - [optional] Annotated tags will populate the PeeledObjectId property. default is false.
     * @param filterContains - [optional] A filter to apply to the refs (contains).
     * @param top - [optional] Maximum number of refs to return. It cannot be bigger than 1000. If it is not provided but continuationToken is, top will default to 100.
     * @param continuationToken - The continuation token used for pagination.
     */
    getRefs(repositoryId: string, project?: string, filter?: string, includeLinks?: boolean, includeStatuses?: boolean, includeMyBranches?: boolean, latestStatusesOnly?: boolean, peelTags?: boolean, filterContains?: string, top?: number, continuationToken?: string): Promise<VS_Services.PagedList<Git.GitRef>>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve statistics for multiple commits
     * 
     * @param searchCriteria - Base Commit and List of Target Commits to compare.
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     */
    public async getBranchStatsBatch(
        searchCriteria: Git.GitQueryBranchStatsCriteria,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitBranchStats[]> {

        return this.beginRequest<Git.GitBranchStats[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/stats/branches",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: searchCriteria
        });
    }

    /**
     * Queries the provided repository for its refs and returns them.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param filter - [optional] A filter to apply to the refs (starts with).
     * @param includeLinks - [optional] Specifies if referenceLinks should be included in the result. default is false.
     * @param includeStatuses - [optional] Includes up to the first 1000 commit statuses for each ref. The default value is false.
     * @param includeMyBranches - [optional] Includes only branches that the user owns, the branches the user favorites, and the default branch. The default value is false. Cannot be combined with the filter parameter.
     * @param latestStatusesOnly - [optional] True to include only the tip commit status for each ref. This option requires \`includeStatuses\` to be true. The default value is false.
     * @param peelTags - [optional] Annotated tags will populate the PeeledObjectId property. default is false.
     * @param filterContains - [optional] A filter to apply to the refs (contains).
     * @param top - [optional] Maximum number of refs to return. It cannot be bigger than 1000. If it is not provided but continuationToken is, top will default to 100.
     * @param continuationToken - The continuation token used for pagination.
     */
    public async getRefs(
        repositoryId: string,
        project?: string,
        filter?: string,
        includeLinks?: boolean,
        includeStatuses?: boolean,
        includeMyBranches?: boolean,
        latestStatusesOnly?: boolean,
        peelTags?: boolean,
        filterContains?: string,
        top?: number,
        continuationToken?: string
        ): Promise<VS_Services.PagedList<Git.GitRef>> {

        const queryValues: any = {
            filter: filter,
            includeLinks: includeLinks,
            includeStatuses: includeStatuses,
            includeMyBranches: includeMyBranches,
            latestStatusesOnly: latestStatusesOnly,
            peelTags: peelTags,
            filterContains: filterContains,
            '$top': top,
            continuationToken: continuationToken
        };

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/refs/{*filter}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<Git.GitRef>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

}

export const GitClientName = "Repos.CommitActions.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
